import type { MeContext } from '@vizit/api';
import { ROLE, SCOPE_TYPE } from '../constants';
import { hasGrant } from './grants';

export function isSuperAdmin(context: MeContext): boolean {
  return context.isSuperAdmin || hasGrant(context, ROLE.SuperAdmin, SCOPE_TYPE.Global);
}
